<template>
  <div>
    <div class="titlePdf text-center html2pdf__page-break">
      <p class="font-size-36 text-dark font-weight-semibold" style="font-size: 36px">判定結果</p>
      <div style="text-align: left;font-size: 18px;color: black;margin-top: 300px;margin-left: -100px">
        <p> 名前 : {{ infoPDF && infoPDF.information ? infoPDF.information.fullname : "" }}
        </p>
        <p>ID : {{ infoPDF.patient_id }}</p>
        <p>性別 : {{ infoPDF.information && infoPDF.information.sex === 0 ? "女性" : infoPDF.information && infoPDF.information.sex === 1 ? "男性" : "無回答"}}</p>
        <p>質問 ：測定</p>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-9">
        <table>
          <tbody v-for="(testResult, indexHis) in items" class="html2pdf__page-break" :key="indexHis">
          <tr style="cursor: pointer">
            <td style="border-bottom-width: 0">
              <div>
                <p class="mt-1 text-black" style="font-size: 14px; margin-bottom: 3px">
                  {{ testResult.created_at | fomatDate2 }}
                </p>
              </div>
              <div style="font-size: 13px">
                <div class="row mt-3">
                  <div class="col-9"><strong>WBI:</strong> {{ testResult.wbi}}</div>
                </div>
                <div class="row mt-3">
                  <div class="col-9"><strong>KL分類（左脚）:</strong> {{testResult.kl_left}}</div>
                  <div class="col-3"><strong>KL分類（右脚）:</strong> {{testResult.kl_right}}</div>
                </div>
                <div class="row mt-3">
                  <div class="col-9"><strong>立ち上がりテスト:</strong> {{ standUpChoices[testResult.stand_up_choice_id]?.name }}</div>
                  <div class="col-3"><strong>ロコモ度:</strong> {{ testResult.stand_up_choice_value }}</div>
                </div>
                <div class="row mt-3">
                  <div class="col-9"><strong>2ステップテスト:</strong> {{ testResult.two_step ? testResult.two_step + '（２ステップ値）': '' }}</div>
                  <div class="col-3"><strong>ロコモ度:</strong> {{ twoStepResult(testResult.two_step) }}</div>
                </div>
                <div class="row mt-3">
                  <div class="col-9"><strong>ロコモ25:</strong> {{testResult.locomo25_score ? testResult.locomo25_score + ' 点' : '' }}</div>
                  <div class="col-3"><strong>ロコモ度:</strong> {{ testResult.locomo25_rank }}</div>
                </div>
                <div class="row mt-3">
                  <div class="col-9"><strong>5m歩行テスト:</strong> {{ testResult.five_meter ? testResult.five_meter + 'm / 秒' : '' }}</div>
                </div>
                <div class="row mt-3">
                  <div class="col-9"><strong>痛みの評価-eVAS:</strong> {{ testResult.vas }}</div>
                </div>
                <div class="row mt-3">
                  <div class="col-9"><strong> FIMの評価表：</strong> {{ testResult.fim ? testResult.fim + ' 点' : '' }}</div>
                </div>
                <div v-if="testResult.fim" class="col-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th class="col-5">評価項目</th>
                        <th class="col-2">点数</th>
                        <th class="col-5" >コメント</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="answer in testResult.dataFim" :key="answer.id">
                        <td>{{ getFimQuestionName(answer.fim_question_id) }} {{ answer.choices ? '（'+ answer.choices + '）' : ''}} </td>
                        <td>{{ answer.answer }}</td>
                        <td>{{ answer.note }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row mt-3">
                  <div class="col-9"><strong>BIの評価表：</strong> {{ testResult.bi ? testResult.bi + ' 点' : '' }}</div>
                </div>
                <div v-if="testResult.bi" class="col-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th class="col-5">評価項目</th>
                        <th class="col-2">点数</th>
                        <th class="col-5">質問内容</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="answer in testResult.dataBi" :key="answer.id">
                        <td>{{ getBiQuestionName(answer.bi_question_id) }} </td>
                        <td>{{ answer.answer }}</td>
                        <td>{{ answer.note }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { filter } from "../../helpers/Vue-Filter";
import { hospitalMethods } from "@/state/helpers";
import { hospitalComputed } from "@/state/helpers";
import api from "@/api";

export default {
  filters: {
    ...filter,
  },
  props: ["items", "infoPDF"],
  data() {
    return {
      standUpChoices: {},
      fimQuestionList:[],
      biQuestionList:[],
    };
  },

  async created() {
    await this.refreshStandUpChoices();
    this.fimQuestionList =  await api.getFimQuestion()
    this.biQuestionList =  await api.getBiQuestion()
  },

  computed: {
    ...hospitalComputed,
  },

  methods: {
    ...hospitalMethods,

    getFimQuestionName(fimQuestionId) {
      if(fimQuestionId) {
        const question = this.fimQuestionList.data.find(question => question.id === fimQuestionId);
        return question ? question.question : '';
      } else {
        return '';
      }
    },

    getBiQuestionName(biQuestionId) {
      if(biQuestionId){
        const question = this.biQuestionList.data.find(question => question.id === biQuestionId);
        return question ? question.question : '';
      }
      else {
        return '';
      }
    },

    async refreshStandUpChoices() {
      const res = await api.listStandUpChoices();
      res.data.forEach((i) => {
        this.standUpChoices[i.id] = i;
      });
    },

    twoStepResult(val) {
      if (val >= 1.1 && val <= 1.3) {
        return 1;
      }

      if (val >= 0.9 && val < 1.1) {
        return 2;
      }

      if (val >= 0 && val < 0.9) {
        return 3;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Noto Sans JP";
}

.text-answers {
  color: #000000;
  font-weight: 700;
  font-size: 12px;
}

.icon-locomo {
  color: #810d20;
}

.color-locomo {
  color: black !important;
  font-size: 18px;
}

.color-level {
  font-weight: 700;
  font-size: 20px;
}

.label-answers {
  color: #d3d3d3;
  font-size: 14px;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

.titlePdf {
  margin: auto;
  width: 50%;
  padding: 10px;
  //   height: 100px !important;
  margin-top: 50%;
}

.text-list-locomo-7 {
  color: #1d1d1d;
  font-size: 16px;
  font-weight: 700;
}

* {
  font-family: "Noto Sans JP";
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  color: #404040;
}

.text-link {
  color: #336aff;
}

.bg-active-locomo {
  background: #f8f9fa;
}

.text-end {
  align-items: end;
}

.scroll {
  height: 300px;
  overflow-y: scroll;
}
  .font-size-36 {
    font-size: 36px;
  }
</style>
